import Button from "../Button/Button";
import { Trans } from "react-i18next";
import { useTranslation } from "react-i18next";
import "./styles.css";
import { CheckBox } from "../CheckBox/CheckBox";
import { useEffect, useState } from "react";
import { HairScanIcon } from "../icons/HairScanIcon/HairScanIcon";
import { useUID } from "../../context/UIDContext";
import { useAmplitude } from "../../context/AmplitudeContext";

export const ValidatePage = ({ onFinish }) => {
  const { t } = useTranslation("homeModule");
  const { uid } = useUID();
  const trackEvent = useAmplitude();

  const [isAcceptMarked, setIsAcceptMarked] = useState(false);
  const [isLicenseMarked, setIsLicenseMarked] = useState(false);
  const [isContinuePressed, setIsContinuePressed] = useState(false);

  useEffect(() => {
    trackEvent("webapp_user_visited_preparation_page", uid);
  }, [trackEvent, uid]);

  return (
    <>
      <div className="validate-page-contents-wrapper">
        <div className="validate-content-area">
          <div className="validate-header-container">
            <h2 className="validate-title">{t("validate-title")}</h2>
            <p className="validate-sub-title">{t("validate-sub-title")}</p>
          </div>
          <div className="validate-images-container">
            <HairScanIcon />
          </div>
        </div>

        {!isContinuePressed && (
          <div className="licenses-wrapper">
            <div className="license-option">
              <CheckBox
                onClick={() => setIsAcceptMarked((prevValue) => !prevValue)}
              />
              <p className="validate-license-text">
                {t("accept-analysis-text")}
              </p>
            </div>
            <div className="license-option">
              <CheckBox
                onClick={() => setIsLicenseMarked((prevValue) => !prevValue)}
              />
              <p className="validate-license-text">
                <Trans
                  ns="homeModule"
                  i18nKey={"terms-text"}
                  components={{
                    click: (
                      <a
                        href="https://www.iqonicai.com/de/terms-and-conditions"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="validate-license-text"
                      >
                        {" "}
                      </a>
                    ),
                  }}
                />
              </p>
            </div>
          </div>
        )}
      </div>

      {!isContinuePressed && (
        <div className="home-button-wrapper">
          <Button
            text={t("continue")}
            onClick={() => {
              trackEvent("webapp_user_press_continue_preparation_page", uid);
              setIsContinuePressed(true);
              setTimeout(() => onFinish(), 1000);
            }}
            disabled={!isLicenseMarked || !isAcceptMarked}
          />
        </div>
      )}
    </>
  );
};
